import type { VariantId } from '../lib/variants'
import type { DesignModule } from './types'
import { v1 } from './v1'
import './v1/tokens.css'
import { v2 } from './v2'
import './v2/tokens.css'
import { v3 } from './v3'
import './v3/tokens.css'

export const DESIGNS: Record<VariantId, DesignModule> = { v1, v2, v3 }
